import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useScrollLock } from "../../hooks/useScrollLock";
import { getUserComments, getUserData } from "../../features/user/userSlice";
import { showNestedModal } from "../../features/modal/modalSlice";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
import styled from "styled-components";
import question from "../../images/svg/question.svg";
import ReactStars from "react-stars";
import Button from "../shared/Button";
import { surucuyuDegerlendir } from "../../features/loadList/loadListSlice";

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;
  .modal {
    width: 1000px;
    max-height: 700px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    /* padding: 20px 50px; */
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    padding: 30px;
    border-radius: 20px;
    .content {
      width: 100%;
      /* display: flex;
            flex-direction: column;
            align-items: center; */
      gap: 15px;
      .top-side {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .image-box {
          img {
            width: 100px;
            height: 100px;
            margin-right: 10px;
          }
        }
        .profil-info {
          p {
            font-size: 14px;
            font-weight: 500;
            line-height: 15px;
            color: #000;
          }
        }
      }
      .main {
        .start-content {
          .comments {
            margin-block: 10px;
            p {
              font-size: 12px;
              font-weight: 400;
              line-height: 15px;
              color: #000;
            }
          }
        }
      }
      .message {
        width: 100%;
        margin-block: 10px;
        textarea {
          width: 100%;
          min-height: 200px;
          padding: 20px;
          background-color: #efeded;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 400;
          line-height: 15px;
          color: #000;
        }
      }
    }
  }
`;

const SurucuProfilDegerlendirModal = () => {
  const dispatch = useDispatch();
  const { userData, selectUserData } = useSelector(
    (state) => state.user
  );
  const { lockScroll, unlockScroll } = useScrollLock();
  const { theme } = useSelector((state) => state.layout);

  const [ekipmanRate, setEkipmanRate] = useState(null);
  const [teslimatSuresiRate, setTeslimatSuresiRate] = useState(null);
  const [iletisimRate, setIletisimRate] = useState(null);
  const [comment, setComment] = useState("");

  const src = process.env.REACT_APP_API_IMG_URI;

  useEffect(() => {
    dispatch(getUserData(selectUserData?.driverPhoneNumber));
  }, []);

  useEffect(() => {
    dispatch(getUserComments({ userId: userData?.id, page: 1 }));
  }, [userData]);

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  const handleSubmit = () => {
    const degerlendirme = {
      truckerId: selectUserData.aspiredLoadOwnerId,
      shipmentId: selectUserData.id,
      comment,
      deliveryTimeandReliability: teslimatSuresiRate,
      communicationandCustomerService: iletisimRate,
      equipmentCondition: ekipmanRate,
    };
    dispatch(surucuyuDegerlendir(degerlendirme));
  };

  return (
    <ModalContainer onClick={() => dispatch(showNestedModal(null))}>
      <div
        className="modal"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="content">
          <div className="top-side">
            <div className="image-box">
              <img src={userData?.profilePhoto ? `${src}${userData?.profilePhoto}` : question} alt={selectUserData?.driverName} />
            </div>
            <div className="profil-info">
              <p>{selectUserData?.driverName}</p>
            </div>
          </div>

          <div className="main">
            <div className="start-content">
              <div className="comments">
                <p>Teslimat Süresi ve Güvenilirlik</p>
                <ReactStars
                  value={teslimatSuresiRate}
                  onChange={(newRating) => setTeslimatSuresiRate(newRating)}
                  size={25}
                  count={5}
                  color1={theme === "dark" ? "#E85446" : "#EFEDED"}
                  color2={theme === "dark" ? "#EFEDED" : "#E85446"}
                />
              </div>
              <div className="comments">
                <p>İletişim ve Müşteri Hizmetleri</p>
                <ReactStars
                  value={iletisimRate}
                  onChange={(newRating) => setIletisimRate(newRating)}
                  size={25}
                  count={5}
                  color1={theme === "dark" ? "#E85446" : "#EFEDED"}
                  color2={theme === "dark" ? "#EFEDED" : "#E85446"}
                />
              </div>
              <div className="comments">
                <p>Ekipman Durumu</p>
                <ReactStars
                  value={ekipmanRate}
                  onChange={(newRating) => setEkipmanRate(newRating)}
                  size={25}
                  count={5}
                  color1={theme === "dark" ? "#E85446" : "#EFEDED"}
                  color2={theme === "dark" ? "#EFEDED" : "#E85446"}
                />
              </div>
            </div>
          </div>
          <div className="message">
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Yorumlarınızı girebilirsiniz."
            ></textarea>
          </div>
          <Button handleClick={handleSubmit} background="#E85446" text="Gönder" radius="10px" padding="10px" width="initial" />
        </div>
      </div>
    </ModalContainer>
  );
};

export default SurucuProfilDegerlendirModal;
